import React from "react";
import axios from "axios";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import FileUploader from "../../components/common/FileUploader";
import { Button } from "shards-react";

class EditModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      course_data: [],
      image: "",
      upload: false,
    };
  }

  fileSelectedHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  createNotification = (type) => {
    switch (type) {
      case "info":
        NotificationManager.info("Info message", 1000);
        break;
      case "success":
        this.updateChecker();
        NotificationManager.success(
          "Success message",
          "Successfully Post",
          1000
        );
        break;
      case "warning":
        NotificationManager.warning(
          "Warning message",
          "Close after 3000ms",
          1000
        );
        break;
      case "error":
        NotificationManager.error(
          "Error message",
          "Something is wrong! Retry again",
          1000,
          () => {
            alert("callback");
          }
        );
        break;
    }
  };

  getModule = () => {
    const id = localStorage.getItem("id");
    axios
      .get(`${process.env.REACT_APP_API_URL}/modules/` + id, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((result) => {
        this.setState({
          data: result.data.modules,
          image: result.data.modules[0].cover,
        });
      });
  };

  componentDidMount() {
    this.getModule();
    this.getCourse();
  }

  getCourse = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/courses`, {
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        this.setState({
          course_data: res.data.courses,
        });
      });
  };

  updateChecker = () => {
    if (this.state.upload === true) {
      this.props.history.push("/module-list");
    }
  };

  onSubmit = (e) => {
    const id = localStorage.getItem("id");
    e.preventDefault();
    if (this.state.image === "") {
      this.createNotification("error");
    } else {
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/modules/` + id,
          {
            title: e.target.title.value,
            cover: this.state.image,
            desc: e.target.desc.value,
            course_id: parseInt(e.target.course.value),
          },
          { headers: { "x-access-token": localStorage.getItem("jwtToken") } }
        )
        .then((res) => {
          if (res.status === 200) {
            this.setState = {
              upload: true,
            };
            this.createNotification("success");
          } else {
            this.createNotification("error");
          }
        });
    }
  };

  isParentCourse = (courseId) => courseId === this.state.data[0].course_id;

  render() {
    return (
      <React.Fragment>
        <NotificationContainer />
        <section className="hero-section pt-50 pb-50">
          <div className="container">
            <div className="col-md-12 col-lg-12 ">
              <h1 className="event-title">Edit Module</h1>
              <div className="card login-signup-card shadow-lg mb-0">
                <div className="card-body px-md-5 py-5">
                  {this.state.data.map((item, index) => (
                    <form
                      key={index}
                      // className="login-signup-form"
                      onSubmit={this.onSubmit}
                    >
                      <label className="pb-1"> Cover Image</label>
                      <FileUploader
                        label="Upload Cover"
                        onUploadSuccess={(imagePath) =>
                          this.setState({ image: imagePath })
                        }
                        onError={(message) => this.createNotification("error")}
                      />

                      <div>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={this.state.image}
                        >
                          {this.state.image}
                        </a>
                      </div>
                      <label className="pb-1">Module Title</label>
                      <div className="input-group input-group-merge">
                        <input
                          defaultValue={item.title}
                          onChange={this.onChange}
                          type="text"
                          name="title"
                          className="form-control"
                          placeholder="Event Title"
                          required
                        />
                      </div>

                      <label className="pb-1">Module Desc</label>
                      <div className="input-group input-group-merge">
                        <textarea
                          defaultValue={item.desc}
                          onChange={this.onChange}
                          type="textarea"
                          name="desc"
                          className="form-control"
                          placeholder=""
                          rows={5}
                          required
                        />
                      </div>
                      <label className="pb-1">Course for Module</label>
                      <select
                        name="course"
                        onChange={this.onChange}
                        className="input-group input-group-merge form-control"
                      >
                        {this.state.course_data.map((item, index) => (
                          <option
                            value={item.id}
                            key={index}
                            selected={this.isParentCourse(item.id)}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      <Button
                        type="submit"
                        value="submit"
                        className="submit-btn"
                      >
                        Submit
                      </Button>
                    </form>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default EditModule;
